"use client";

import React from "react";

//Styles
import * as S from "./styles";
import { BoxColumnsProps } from "@/types";

const BoxColumns: React.FC<BoxColumnsProps> = ({
  className,
  columns = 2,
  children,
  marginB = "",
  align = "start",
  justify,
  gap = "15px",
}) => {
  return (
    <S.BoxColumns
      className={className}
      $gap={gap}
      $columns={columns}
      $marginB={marginB}
      $align={align}
      $justify={justify}
    >
      {children}
    </S.BoxColumns>
  );
};

export default BoxColumns;
